export default __webpack_public_path__ + "static/media/step1.aae25b4e.svg";